import {
  BufferAttribute,
  BufferGeometry,
  Line,
  LineBasicMaterial,
  Mesh,
  TorusGeometry,
  Vector3,
} from 'three';
import type { World } from 'cannon-es';
import type { LaunchOptions } from './RescueTool';
import { RescueTool } from './RescueTool';

export class RescueRope extends RescueTool {
  private readonly ropeGeometry: BufferGeometry;
  private readonly ropeLine: Line;
  private origin = new Vector3();

  constructor() {
    super('rope');
    const loop = new Mesh(new TorusGeometry(0.78, 0.09, 8, 24), this.standardMaterial(0xffc83d));
    loop.rotation.x = Math.PI / 2;
    loop.castShadow = true;
    this.group.add(loop);
    this.ropeGeometry = new BufferGeometry();
    this.ropeGeometry.setAttribute('position', new BufferAttribute(new Float32Array(36), 3));
    this.ropeLine = new Line(this.ropeGeometry, new LineBasicMaterial({ color: 0xf7e2a9, linewidth: 2 }));
    this.ropeLine.frustumCulled = false;
  }

  override launch(world: World, options: LaunchOptions): void {
    this.origin.copy(options.origin);
    super.launch(world, options);
  }

  attachTo(sceneGroup: import('three').Group): void {
    sceneGroup.add(this.ropeLine);
  }

  override update(delta: number, riverSpeed: number): void {
    super.update(delta, riverSpeed);
    const positions = this.ropeGeometry.getAttribute('position') as BufferAttribute;
    const end = this.group.position;
    for (let i = 0; i < positions.count; i += 1) {
      const t = i / (positions.count - 1);
      positions.setXYZ(
        i,
        this.origin.x + (end.x - this.origin.x) * t,
        this.origin.y + (end.y - this.origin.y) * t - Math.sin(t * Math.PI) * 0.8,
        this.origin.z + (end.z - this.origin.z) * t,
      );
    }
    positions.needsUpdate = true;
  }

  override dispose(): void {
    this.ropeLine.removeFromParent();
    this.ropeGeometry.dispose();
    (this.ropeLine.material as LineBasicMaterial).dispose();
    super.dispose();
  }
}
